// idleTimer.ts
export default function idleTimer(timeout: number, logoutCallback: any) {
  let timer: number;

  function resetTimer() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      logoutCallback();
    }, timeout);
  }

  function startTimer() {
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("touchstart", resetTimer);
    resetTimer();
  }

  function stopTimer() {
    clearTimeout(timer);
    window.removeEventListener("mousemove", resetTimer);
    window.removeEventListener("keydown", resetTimer);
    window.removeEventListener("touchstart", resetTimer);
  }

  return { startTimer, stopTimer };
}
